import { AppRouteProps } from '@bsm/component'
import React from 'react'
import { UserManagementContainer } from './container/UserManagementContainer'
import { UserOrganisationRoutes } from 'views/organisation/UserOrganisationRoutes'
import { UserListRoutes } from 'views/list/UserListRoutes'
import { UserDetailsRoutes } from 'views/user-details/UserDetailsRoutes'
import { GroupsDetailsRoutes } from 'views/organisation/views/groups/views/details/GroupsDetailsRoutes'
import { Outlet } from 'react-router-dom'

export const UserManagementRoutes: Array<AppRouteProps> = [
    {
        path: "",
        element: <UserManagementContainer />,
        children: [
            ...UserOrganisationRoutes,
            ...UserListRoutes,
            ...UserDetailsRoutes,
        ]
    },
    {
        path: "",
        element: <Outlet />,
        children: [
            ...GroupsDetailsRoutes
        ]
    }
]
